import React, { Component } from "react";
import Link from "gatsby-link";
import PropTypes from "prop-types";

class Section extends Component {
  constructor(props) {
    super(props);
  }

  static propTypes = {
    header: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    subHeader: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array,
      PropTypes.object
    ]),
    paragraph: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array,
      PropTypes.object
    ]),
    linkText: PropTypes.string,
    style: PropTypes.object,
    bgColor: PropTypes.string,
    fullWidth: PropTypes.bool,
    anchor: PropTypes.string
  };

  ifNotFullWidth() {
    return this.props.fullWidth ? "" : this.props.children;
  }

  ifFullWidth() {
    return this.props.fullWidth ? this.props.children : "";
  }

  renderParagraph = () => {
    let content = undefined;
    const propType = typeof this.props.paragraph;

    // TODO: Discuss: Would this be better with as an If/Else?
    switch (propType) {
      case "object": {
        content = this.props.paragraph;
        break;
      }
      case "string": {
        content = <p style={{ lineHeight: "24px" }}>{this.props.paragraph}</p>;
        break;
      }
      case "array": {
        content = this.props.paragraph;
        break;
      }
      default: {
        content = this.props.paragraph;
      }
    }

    return this.props.paragraph ? content : undefined;
  };

  render() {
    const bgStyle = {
      backgroundColor: this.props.bgColor
    };

    return (
      <section
        className={`${this.props.className || "pt-5 pb-5"}`}
        style={Object.assign(bgStyle, this.props.style)}
        id={this.props.anchor}
      >
        <div className="container marketingSection">
          <div className="row align-items-center">
            <div
              className={`col-md-${this.props.infoWidth || "12"} ${
                this.props.textAlign
                  ? "text-sm-center text-md-left"
                  : "text-center"
              }`}
            >
              {this.props.header ? (
                <h2 className="hide">{this.props.header}</h2>
              ) : (
                ""
              )}
              {this.props.subHeader ? <h3>{this.props.subHeader}</h3> : ""}
              {this.props.paragraph ? <p>{this.props.paragraph}</p> : ""}
              {this.props.linkText ? (
                <p>
                  <Link to={this.props.linkUrl} className="tinyLink">
                    {this.props.linkText}
                  </Link>
                </p>
              ) : (
                ""
              )}
              {this.ifNotFullWidth()}
            </div>
          </div>
        </div>
        {this.ifFullWidth()}
      </section>
    );
  }
}

export default Section;



// WEBPACK FOOTER //
// ./src/sections/layouts/section.js